import { CurrencyConfig } from '@/types/currency';
import { ApiAxiosInstance } from '../instances/apiAxiosInstance';


export const routeClient = {
  getCurrencyConfig(currencyCode: string) {
    return ApiAxiosInstance.get<CurrencyConfig[]>('route/b2b/currency-config', {
      params: {
        currencyCode,
      },
    });
  },
};
